import BenchlingConfig from 'BenchlingConfig';

/**
 * Agent keep in sync: _is_row_by_row_submission_required in
 * benchling/notebook/structured_tables/api/action_functions.py.
 */
export default function isRowOnlySubmissionRequired(structuredTable?: {
  metadata?: {rowByRowSubmissionRequired?: boolean};
}): boolean {
  return (
    BenchlingConfig.ELN_ENABLE_ROW_ONLY_TABLE_SUBMISSION &&
    structuredTable?.metadata?.rowByRowSubmissionRequired === true
  );
}
